.profileIcon {
  path {
    /* stylelint-disable-next-line declaration-no-important */
    fill: var(--bloom-colors-header-contrast) !important;
  }
}

.promptIcons {
  color: color-mix(in srgb, var(--colors-primary-main) 50%, white);
}

.ctaLink {
  display: block;
  width: 100%;
}
